<style>

.stars-margin{
  margin-right: 8px;
}
.container{
  font-size: 21px;
  display: grid;
  font-size: 17px;
}
.reviews{
  display: inline;
  margin-top: -5px;
  font-size: 25px;
}
.size{
  font-size: 17px;
}
.icon-star, .icon-star_half, .icon-star_outline {
  margin-left: 8px;
}
.large-stars{
  font-size: 30px;
  margin-left: auto;
}
</style>

<div class="container">
  
  {#if edit || stars}
  
  <div class="stars {largeStars == false ? 'stars-margin' : ''}">
    {#each items as item, index}
      {#if item == 1}
        <i class="icon-star {largeStars ? 'large-stars' : ''}" on:click="{ () => starClick(index) }"></i>
      {:else if item == 2}
        <i class="icon-star_half {largeStars ? 'large-stars' : ''}" on:click="{ () => starClick(index) }"></i>
      {:else}
        <i class="icon-star_outline {largeStars ? 'large-stars' : ''}" on:click="{ () => starClick(index) }"></i>
      {/if}
    {/each}
    
  </div>
  
  <div class="reviews">
    {#if reviews >= 0}
      <!-- ({reviews}) {text} -->
    {/if}
  </div>
  
  {:else}
  
  {#if readWrite}
  <div class="size" on:click="{ () => edit = true }"><i class="icon-star_outline"></i> Tap To Rate</div>
  {:else}
  <div class="size"><i class="icon-star_outline"></i> Not Rated</div>
  {/if}
  
  {/if}
  
</div>


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

export let stars = 0;
export let reviews = 250;
export let text = "";
export let largeStars = true;
export let readWrite = false;

let edit = false;

let items = [0,0,0,0,0];

$:{
  if (stars) set();
}


function set() {
  items = [0,0,0,0,0];
  
  let pos = 0;
  for ( let i = stars; i > 0; i-=1.0 ) {
    
    if (i >= 1) {
      items[pos] = 1;
    } else {
      items[pos] = 2;
    }
    
    pos++;
  }
}


function starClick(index) {
  if (readWrite == true) {
    stars = index + 1;
    dispatch("updated", {stars: stars});
  }
}


</script>